import { render } from "./testimonials-list.vue?vue&type=template&id=38e02bb3"
import script from "./testimonials-list.vue?vue&type=script&lang=js"
export * from "./testimonials-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__